export default function LocationBenefits() {
  const benefits = [
    {
      number: '01',
      title: 'Localização Privilegiada',
      description: 'Três Barras, o bairro que mais valoriza em Linhares, com infraestrutura completa e acesso facilitado'
    },
    {
      number: '02',
      title: 'Valorização Constante',
      description: 'Região em franco desenvolvimento com alta demanda e valorização imobiliária comprovada'
    },
    {
      number: '03',
      title: 'Infraestrutura Completa',
      description: 'Próximo a comércios, serviços, escolas, hospitais e principais vias de acesso da cidade'
    },
    {
      number: '04',
      title: 'Investimento Seguro',
      description: 'Seja para morar ou investir, a melhor escolha para seu patrimônio em Linhares'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-amber-600 text-sm tracking-[0.3em] uppercase mb-4 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
              Localização Premium
            </p>
            <h2 className="text-5xl lg:text-6xl font-normal text-gray-900 mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
              A Região Que Mais Valoriza
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
              Três Barras é reconhecido como o bairro de maior valorização imobiliária em Linhares. Uma localização estratégica que combina qualidade de vida, infraestrutura completa e excelente potencial de valorização.
            </p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-2xl text-amber-600"></i>
                <span className="text-sm font-medium text-gray-700" style={{ fontFamily: 'Inter, sans-serif' }}>Três Barras, Linhares - ES</span>
              </div>
            </div>
          </div>
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/c6fe8d889f716aced18edb384e32a3af.jpg"
              alt="Localização Três Barras Linhares"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="flex gap-6 p-8 rounded-lg bg-gray-50 hover:bg-amber-50 transition-all duration-300 group"
            >
              <div className="flex-shrink-0">
                <span className="text-5xl font-normal text-amber-600/30 group-hover:text-amber-600/50 transition-all duration-300" style={{ fontFamily: 'DM Serif Display, serif' }}>
                  {benefit.number}
                </span>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'DM Serif Display, serif' }}>
                  {benefit.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-600 to-amber-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-normal mb-4" style={{ fontFamily: 'DM Serif Display, serif' }}>
            Invista no Futuro de Linhares
          </h3>
          <p className="text-base max-w-2xl mx-auto leading-relaxed opacity-90" style={{ fontFamily: 'Inter, sans-serif' }}>
            Garanta sua unidade na localização mais valorizada da cidade e faça parte de um empreendimento exclusivo que une sofisticação, conforto e excelente potencial de retorno.
          </p>
        </div>
      </div>
    </section>
  );
}
